import { memo } from 'react';
import QuestionViewer from '../QuestionViewer';
import IndicatorFieldsEditor, {
  IndicatorFieldsViewer,
} from './IndicatorFields';
import {
  IIndicatorQuestionView,
  QuestionState,
} from 'store/survey/surveyTypes';
import { appDispatch } from '../../../../../../store/store';
import { IQuestionViewerProp } from '../GeneralQuestion/GeneralQuestionViewer';

interface IOwnProps extends IQuestionViewerProp {
  question: { data: IIndicatorQuestionView; state: QuestionState };
}

type IComponentProps = IOwnProps;

const IndicatorQuestionViewer: React.FC<IComponentProps> = ({
  tags,
  index,
  surveyId,
  question,
  displayDeleted,
  providerSurvey,
  readOnly,
  ...otherProps
}) => {
  const {
    data: { unit, numerator, denominator, numeratorUnit, denominatorUnit },
  } = question;
  return (
    <QuestionViewer
      icon="bookmark"
      tags={tags}
      index={index}
      surveyId={surveyId}
      dispatch={appDispatch}
      question={question}
      displayDeleted={displayDeleted}
      readOnly={readOnly}
      providerSurvey={providerSurvey}
      child={(editing: boolean) =>
        !editing ? (
          <IndicatorFieldsViewer
            unit={unit}
            numerator={numerator}
            denominator={denominator}
            numeratorUnit={numeratorUnit}
            denominatorUnit={denominatorUnit}
          />
        ) : (
          <IndicatorFieldsEditor />
        )
      }
      {...otherProps}
    />
  );
};

export default memo(
  IndicatorQuestionViewer //,
  // (prevProps: IComponentProps, nextProps: IComponentProps) => {
  // return (
  //   prevProps.question === nextProps.question &&
  //   prevProps.index == nextProps.index
  // );
  // }
);
